var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-wrapper-full"},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c(_vm.selectedContentComponent,_vm._b({tag:"component",on:{"switchKontraktView":_vm.onSwitchKontraktView}},'component',_vm.theContentVars,false))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b0e657a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/KundeKontrakt.vue
// module id = null
// module chunks = 